// extracted by mini-css-extract-plugin
module.exports = {"button":"_10yZAK9MfMBC_tzs","actions":"_3SRMkOqWxV5W0fF3","title":"keSa7R5okdRmoNf0","text":"_1YXlzE4u5Fy7Nie5","subText":"_2cOgKCpuNspdsST8","xsButton":"_11Pu-1oAj0rRVyBi"};